import { FEEDS } from 'platform/adminPanel/feeds/feed.navigation';
import FeedList from 'platform/adminPanel/feeds/FeedList';

const FEED_ROUTE = { ...FEEDS, component: FeedList };

export default FEED_ROUTE;
